module.exports = __webpack_public_path__ + "img/DNARepair-MELA_GSE185386.dab8a0e7.png";